import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { fetchManagerPerformanceDashboardRequest } from "../../../redux/actions/performanceActions";
import "../PerformanceStyles.css";
import { asArray, statusTone, formatStatus } from "../Collaborateur/performanceUi";
import EntretienAnnuelModal from "../components/EntretienAnnuelModal";

export default function PerformanceManagerCollaborateurs() {
    const { campagneId } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const manager = useSelector((state) => state.performance.manager);
    const collaborateurs = asArray(manager.collaborateursByCampagneId[String(campagneId)]);
    const loading = manager.loadingByCampagneId[String(campagneId)];
    const error = manager.errorByCampagneId[String(campagneId)];
    const [planificationProgressId, setPlanificationProgressId] = useState(null);

    useEffect(() => {
        dispatch(fetchManagerPerformanceDashboardRequest(campagneId));
    }, [dispatch, campagneId]);

    const openEvaluation = (progressId) => {
        if (!progressId) return;
        navigate(`/performance/manager/evaluation/${progressId}`);
    };

    return (
        <main className="perf-page">
            <header className="perf-header">
                {/*<div>*/}
                {/*    <h1>Collaborateurs campagne</h1>*/}
                {/*    <p>Campagne #{campagneId} - progression fournie par le backend.</p>*/}
                {/*</div>*/}
            </header>
            {loading && <div className="perf-state">Chargement des collaborateurs...</div>}
            {error && <div className="perf-state perf-state--error">{error}</div>}
            {!loading && !error && collaborateurs.length === 0 && <div className="perf-state">Aucun collaborateur rattache a cette campagne.</div>}
            {!loading && !error && collaborateurs.length > 0 && (
                <section className="perf-table-wrap">
                    <table className="perf-table">
                        <thead>
                        <tr>
                            <th>Collaborateur</th>
                            <th>Poste</th>
                            <th>Direction</th>
                            <th>Statut</th>
                            <th>Progression</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        {collaborateurs.map((collaborateur) => (
                            <tr key={collaborateur.evaluationProgressId}>
                                <td>{collaborateur.collaborateurNom || "-"}</td>
                                <td>{collaborateur.jobName || "-"}</td>
                                <td>{collaborateur.entityName || "-"}</td>
                                <td><span className={`perf-badge perf-badge--${statusTone(collaborateur.globalStatus)}`}>{formatStatus(collaborateur.globalStatus)}</span></td>
                                <td>{collaborateur.progressionPourcentage ?? 0}%</td>
                                <td>
                                    <div className="perf-actions perf-actions--table">
                                        <button className="perf-btn" type="button" disabled={!collaborateur.evaluationProgressId} onClick={() => openEvaluation(collaborateur.evaluationProgressId)}>Consulter</button>
                                        <button className="perf-btn perf-btn--primary" type="button" disabled={!collaborateur.evaluationProgressId} onClick={() => openEvaluation(collaborateur.evaluationProgressId)}>Évaluer / Reprendre</button>
                                        <button className="perf-btn" type="button" disabled={!collaborateur.evaluationProgressId} onClick={() => setPlanificationProgressId(collaborateur.evaluationProgressId)}>Planifier entretien</button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </section>
            )}
            <EntretienAnnuelModal
                open={Boolean(planificationProgressId)}
                progressId={planificationProgressId}
                title="Invitation entretien annuel"
                onClose={() => setPlanificationProgressId(null)}
                showManagerActions
            />
        </main>
    );
}